const colors = {
    darkgrey: '#393d3f',
    lightgrey: '#bfbdc1',
    orange: '#e67f0d'

}

export default colors